// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"070d41a5","156":"e12a0aec","492":"7d7ec6e6","787":"fe4b4c4b"}[chunkId] + ".chunk.js";
};